import InfoMessage from './InfoMessage.component';
export default InfoMessage;